var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.dataFrom.id ? _vm.$t("查看") : _vm.$t("手动统计"),
      visible: _vm.dialogVisible,
      footer: !_vm.dataFrom.id ? undefined : null,
      width: 820
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      },
      ok: _vm.handleSure
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      "label-col": {
        span: 10
      },
      "wrapper-col": {
        span: 14
      },
      rules: _vm.dataRule
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("公司现有人数"),
      prop: "peopleNum"
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.dataFrom.peopleNum,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "peopleNum", $$v);
      },
      expression: "dataFrom.peopleNum"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("总持证数"),
      prop: "licensesNum"
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.dataFrom.licensesNum,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "licensesNum", $$v);
      },
      expression: "dataFrom.licensesNum"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("高级管理人员"),
      prop: "adminNum"
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.dataFrom.adminNum,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "adminNum", $$v);
      },
      expression: "dataFrom.adminNum"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("高级管理人员持证数"),
      prop: "adminLicensesNum"
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.dataFrom.adminLicensesNum,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "adminLicensesNum", $$v);
      },
      expression: "dataFrom.adminLicensesNum"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("业务人员人数"),
      prop: "businessNum"
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.dataFrom.businessNum,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "businessNum", $$v);
      },
      expression: "dataFrom.businessNum"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("业务人员持证数"),
      prop: "businessLicensesNum"
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.dataFrom.businessLicensesNum,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "businessLicensesNum", $$v);
      },
      expression: "dataFrom.businessLicensesNum"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("非业务人员人数"),
      prop: "onBusinessNum"
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.dataFrom.onBusinessNum,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "onBusinessNum", $$v);
      },
      expression: "dataFrom.onBusinessNum"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("非业务人员持证数"),
      prop: "onBusinessLicensesNum"
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.dataFrom.onBusinessLicensesNum,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "onBusinessLicensesNum", $$v);
      },
      expression: "dataFrom.onBusinessLicensesNum"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("同比") + "（+/-）",
      prop: "grew"
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.dataFrom.grew,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "grew", $$v);
      },
      expression: "dataFrom.grew"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };